// ============================================================================
// CONFIGURATION - Update these values
// ============================================================================
const API_CONFIG = {
  webhookUrl: 'https://n8n.srv1112008.hstgr.cloud/webhook/chat-widget-webhook',
  authToken: '18981939141794',
  timeout: 30000
};

/**
 * Send message to n8n webhook
 * @param {string} message - User's message
 * @param {string} sessionId - Unique session identifier
 * @returns {Promise<Object>} Response from API
 */
export const sendMessageToAPI = async (message, sessionId) => {
  try {
    const payload = {
      message: message,
      sessionId: sessionId,
      timestamp: new Date().toISOString(),
      source: 'react-widget',
      page: window.location.href,
      user_agent: navigator.userAgent
    };

    console.log('Sending message to API:', payload);

    const response = await fetch(API_CONFIG.webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'AI-Customer-Support-Agent-N8N-Webhook-Auth': API_CONFIG.authToken
      },
      body: JSON.stringify(payload),
      signal: AbortSignal.timeout(API_CONFIG.timeout)
    });

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return {
        success: false,
        forceFallback: true,
        response: "I apologize, but I'm having trouble connecting to the server right now.",
        sessionId: sessionId
      };
    }

    const data = await response.json();
    console.log('API response:', data);

    // Check if JSON is valid
    if (!data || typeof data !== 'object') {
      return {
        success: false,
        forceFallback: true,
        response: "System did not return a valid response.",
        sessionId: sessionId
      };
    }

    return {
      success: true,
      response: data.response || data.output || data.message || 'I received your message.',
      sessionId: data.sessionId || sessionId,
      processedAt: data.processedAt || new Date().toISOString(),
      forceFallback: data.forceFallback || false
    };

  } catch (error) {
    console.error('Chat service error:', error);
    
    return {
      success: false,
      forceFallback: true,
      response: "I apologize, but I'm having trouble connecting to the server right now.",
      error: error.message,
      sessionId: sessionId
    };
  }
};

/**
 * Send lead escalation form data
 * @param {Object} formData - Lead form data
 * @returns {Promise<Object>} Response from server
 */
export const sendLeadEscalation = async (formData) => {
  try {
    // Note: Update this URL to your actual escalation endpoint
    const escalateUrl = '/wp-json/chat-widget/v1/escalate';
    
    const response = await fetch(escalateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': window.wpApiSettings?.nonce || ''
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Lead escalation error:', error);
    return {
      success: false,
      message: 'Failed to send request. Please try again.'
    };
  }
};